import { useQuery } from "@tanstack/react-query";
import { Datanode } from "@graylog/server-api";
import usePermissions from "hooks/usePermissions";
const DATANODE_CONFIGURED_QUERY_KEY = ["datanode", "configured"];
const STALE_TIME_MS = 3e5;
const useRunsWithDataNode = ({ enabled = true } = {}) => {
  const { isPermitted } = usePermissions();
  const { data, isLoading } = useQuery({
    queryKey: DATANODE_CONFIGURED_QUERY_KEY,
    queryFn: () => Datanode.runsWithDataNode({ requestShouldExtendSession: false }),
    enabled: enabled && isPermitted("datanode:read"),
    staleTime: STALE_TIME_MS
  });
  return { data, isLoading };
};
export default useRunsWithDataNode;
